<template>
  <div>
    <modal-role :data="this.data_row" />
    <!-- <modal-incident-create /> -->
    <div
      class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    >
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-gray-500 mb-1 text-xs font-semibold">
              Overview
            </h6>
            <h2 class="text-black text-xl font-semibold">
              Roles - Data Table
            </h2>
          </div>
        </div>
      </div>
      <div class="p-4 flex-auto">
        <!-- Chart -->
        <div class="relative">
          <vue-good-table
            :columns="columns"
            :lineNumbers="true"
            :rows="dataRoles"
            @on-row-click="onRowClick"
            :search-options="{
              enabled: true,
              placeholder: 'Search Role'
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <div slot="emptystate" class="text-center">
              No roles available.
            </div>
            <div slot="table-actions">
              <download-csv
                class="bg-blue-600 text-white active:bg-pink-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                :data="dataRoles"
                type="button"
                name="data_roles_table.csv"
              >
                <i class="fas fa-download"></i>
                Download CSV
              </download-csv>
            </div>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: CardRolesTable
  Description: This class representing a table with loaded roles.
*/

/* Imports */
import ModalRole from "@/components/Modals/Roles/ModalRole.vue";
/* /Imports/ */

export default {
  /* 
    Define data with custom roles state values. 
  */
  data() {
    return {
      dataRoles: null,
      data_row: null,
      columns: [
        {
          label: "Name",
          field: "name",
          filterable: true,
        },
        {
          label: "Description",
          field: "description",
          filterable: true,
        },
      ],
      rows: this.dataRoles,
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    ModalRole,
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Show modal for single role. 
    */
    onRowClick(params) {
      this.data_row = params.row;
      this.$modal.show("role");
    },

    /* 
      We got all roles and save them to state. 
    */
    getRoles() {
      this.$loading(true);

      this.$store.dispatch("rolesTable/getAllRoles").then(() => {
        this.dataRoles = this.$store.state.rolesTable.rolesData;

        this.$loading(false);
      });
    }
  },

  /* 
    Load all roles after the instance. 
  */
  mounted() {
    this.getRoles();
  },
};
</script>
